import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './ModelCategories.css';

const ModelCategories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  
  // Simulate fetching categories data
  useEffect(() => {
    // Mock data
    const mockCategories = [
      { 
        id: 'iot', 
        name: 'IoT & Smart Home', 
        count: 48, 
        icon: '🏠',
        description: 'Internet of Things devices for home automation, monitoring, and control systems.',
        popularModels: [
          'Smart Home Hub',
          'WiFi Environmental Monitor',
          'Voice Assistant Integration'
        ],
        imagePath: '/images/categories/iot.jpg'
      },
      { 
        id: 'robotics', 
        name: 'Robotics & Automation', 
        count: 36, 
        icon: '🤖',
        description: 'Autonomous robots, automation systems, and mechanical control projects.',
        popularModels: [
          'Autonomous Robot Platform',
          'Robotic Arm Controller',
          'Line Following Robot'
        ],
        imagePath: '/images/categories/robotics.jpg'
      },
      { 
        id: 'environmental', 
        name: 'Environmental Monitoring', 
        count: 24, 
        icon: '🌱',
        description: 'Systems for monitoring environmental conditions like weather, soil, water, and air quality.',
        popularModels: [
          'Weather Station',
          'Agricultural Monitoring System',
          'Air Quality Monitor'
        ],
        imagePath: '/images/categories/environmental.jpg'
      },
      { 
        id: 'wearables', 
        name: 'Wearable Technology', 
        count: 18, 
        icon: '⌚',
        description: 'Wearable electronic devices for health monitoring, fitness tracking, and interactive clothing.',
        popularModels: [
          'Smart Fitness Tracker',
          'Health Monitoring Device',
          'LED Fashion Accessories'
        ],
        imagePath: '/images/categories/wearables.jpg'
      },
      { 
        id: 'educational', 
        name: 'Educational Projects', 
        count: 42, 
        icon: '🎓',
        description: 'STEM learning projects designed for students, beginners, and educational institutions.',
        popularModels: [
          'LED Matrix Display',
          'Basic Arduino Starter Kit',
          'Educational Robot Kit'
        ],
        imagePath: '/images/categories/educational.jpg'
      },
      { 
        id: 'industrial', 
        name: 'Industrial Applications', 
        count: 29, 
        icon: '🏭',
        description: 'Robust industrial solutions for monitoring, control systems, and automation.',
        popularModels: [
          'Industrial Sensor Gateway',
          'Production Line Monitor',
          'Machine Status Tracker'
        ],
        imagePath: '/images/categories/industrial.jpg'
      },
      { 
        id: 'audio', 
        name: 'Audio & Music', 
        count: 15, 
        icon: '🎵',
        description: 'Sound systems, audio processors, and musical instrument projects.',
        popularModels: [
          'MIDI Controller',
          'Digital Audio Processor',
          'Bluetooth Speaker'
        ],
        imagePath: '/images/categories/audio.jpg'
      },
      { 
        id: 'transportation', 
        name: 'Transportation & Vehicles', 
        count: 12, 
        icon: '🚗',
        description: 'Vehicle monitoring, tracking, and control systems for automotive and transportation.',
        popularModels: [
          'GPS Tracker',
          'Vehicle Diagnostics System',
          'Electric Vehicle Monitor'
        ],
        imagePath: '/images/categories/transportation.jpg'
      }
    ];
    
    // Simulate API delay
    setTimeout(() => {
      setCategories(mockCategories);
      setLoading(false);
    }, 800);
  }, []);
  
  const handleCategoryClick = (categoryId) => {
    // Navigate to models screen with filter
    navigate(`/design-makers-hub/models?category=${categoryId}`);
  };
  
  if (loading) {
    return (
      <div className="categories-loading">
        <div className="loading-spinner"></div>
        <p>Loading categories...</p>
      </div>
    );
  }

  return (
    <div className="model-categories">
      <div className="categories-header">
        <h1>Model Categories</h1>
        <p>Browse our curated collection of electronic design model categories</p>
      </div>
      
      <div className="categories-grid">
        {categories.map(category => (
          <div 
            className="category-card" 
            key={category.id}
            onClick={() => handleCategoryClick(category.id)}
          >
            <div className="category-image">
              <img 
                src={category.imagePath} 
                alt={category.name}
                onError={(e) => {
                  e.target.src = `https://via.placeholder.com/400x240?text=${category.name.replace(/\s+/g, '+')}`;
                }}
              />
              <div className="category-icon">{category.icon}</div>
            </div>
            
            <div className="category-content">
              <div className="category-header">
                <h3>{category.name}</h3>
                <span className="model-count">{category.count} Models</span>
              </div>
              
              <p className="category-description">{category.description}</p>
              
              <div className="popular-models">
                <h4>Popular Models:</h4>
                <ul>
                  {category.popularModels.map((model, index) => (
                    <li key={index}>{model}</li>
                  ))}
                </ul>
              </div>
              
              <button className="browse-category-btn">
                Browse Category
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/>
                </svg>
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ModelCategories;